import React from "react";
import { useParams } from "react-router-dom";
import PokemonStats from "./PokemonStats";
import { typeColors } from '../colors/typeColor';
import PokemonProfileCard from "./PokemonProfileCard";
import { PokemonContext } from "../context/pokemonContext";
import { pokemonDataReducer } from "../reducer/pokemon";
import { pokemonData } from "../actions/pokemon";
import PokemonImageCard from "./PokemonImageCard";

const Pokemon = () => {

    const id=useParams().id;

    const [pokemon, dispatchPokemon] = React.useReducer(pokemonDataReducer,{
        name:'',
        imgUrl:'',
        height:0,
        weight:0,
        types:[],
        stats:[],
        abilities:[],
        color: 'unknown',
        eggGroups:[],
        habitat:'unknown',
        growthRate:'unknown',
        shape:'unknown',
        male:50,
        female:50,
        catchRate:0
    });

    React.useEffect(() => {

        fetch(`https://pokeapi.co/api/v2/pokemon/${id}`)
        .then((response) => response.json())
        .then((data) => {

            dispatchPokemon(pokemonData({
                name: data.species.name,
                imgUrl: data.sprites.other['official-artwork'].front_default,
                height: Math.round((data.height * 0.328084 + 0.00001) * 100) / 100,
                weight: Math.round((data.weight * 0.220462 + 0.00001) * 100) / 100,
                types: data.types,
                stats: data.stats,
                abilities: data.abilities,
            }));
        })
        .catch((error) => {});

        fetch(`https://pokeapi.co/api/v2/pokemon-species/${id}`)
        .then((response) => response.json())
        .then((data) => {

            dispatchPokemon(pokemonData({
                color: data.color ? data.color.name : 'unknwon',
                eggGroups: data.egg_groups,
                habitat: data.habitat ? data.habitat.name : 'unknown',
                growthRate: data.growth_rate ? data.growth_rate.name : 'unknown',
                shape: data.shape ? data.shape.name : 'unknown',
                female: data.gender_rate>0 ? (data.gender_rate/8) * 100 : 50,
                male: data.gender_rate>0 ? (8-data.gender_rate)/8 * 100 : 50,
                catchRate: Math.round((100 / 255) * data.capture_rate),
            }));

            console.log(pokemon);
        })
        .catch((error) => {
            console.log(error)
        });

    }, []);

    console.log(pokemon);


    return (
        <PokemonContext.Provider value={{ pokemon }}>
            <div className="pokemon-profile container">

                <div className="row">

                    <div className="data-cards col-md-5">
                        <PokemonImageCard />
                    </div>

                    <div className="data-cards col-md-7">
                        <PokemonProfileCard />
                        <PokemonStats />
                    </div>
                </div>
            </div>
        </PokemonContext.Provider>
    );
};

export default Pokemon;